















































import { Component, Vue } from "vue-property-decorator";
import SignOut from "../Login/SignOut.vue";

@Component({
  name: "user",
  components: {
    SignOut,
  },
})
export default class User extends Vue {


  
}
